export default "__VITE_PUBLIC_ASSET__10ec39f1__"